// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import HoverTotalProratedCost from './HoverTotalProratedCost'
import HoverProratedDays from './HoverProratedDays'

// Component Imports
// JS Imports
// Asset Imports

export default function EstimatedProratedTotalRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['EstimatedProratedTotal']

   if (
      (permissions.includes(state.user_role) &&
         state.proratedActivationDetails.prorated) ||
      state.proratedActivationDetails.prorated
   )
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.EstimatedProratedTotalRow.Title')}
            </div>
            <div className='col'>
               <HoverProratedDays />
            </div>
            <div className='col'></div>
            <div className='col'>
               <HoverTotalProratedCost />
            </div>
         </div>
      )
}
